import styled, { css } from 'styled-components';

export const Heading = styled.div`
  ${({ theme: { spacing } }) => css`
    padding: 0;
    padding-left: ${spacing.km8};
    height: 4.875rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  `}
`;

export const InputList = styled.fieldset`
  ${({ theme: { spacing } }) => css`
    border: none;
    padding-top: ${spacing.km4};
    overflow-y: auto;
    display: grid;
    grid-gap: ${spacing.km8};
    grid-template-columns: 1fr;
  `}
`;

export const ListItens = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-gap: ${spacing.km4};

    @media (min-width: 769px) {
      grid-template-columns: repeat(2, 2fr);
    }

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  `}
`;
